<template>
  <div class="md-layout md-alignment-top-center">
    <div class="row md-layout-item md-size-100">
      <div class="md-layout-item row md-size-50 md-medium-size-100 md-small-size-100">
      <md-card>
        <md-button
          v-if="activityDetails && activityDetails.userId === this.userId && activityDetails.externalDataSourceId === 40"
          class="md-primary md-just-icon md-round"
          @click="showManualActivityDialog = true"
        >
          <md-icon>edit</md-icon>
        </md-button>
          <activity-overall-info
              v-if="activityDetails"
              :activity="activityDetails.data"
              :userName="activityDetails.userDisplayName"
              :userAvatar="activityDetails.userImage"
              :activityStart="activityDetails.start"
              :activityTitle="activityDetails.title"
              :activityType="activityDetails.activityType"
              :externalDataSourceId="activityDetails.externalDataSourceId"
              :durationInSeconds="activityDetails.durationInSeconds"
              :badges="activityDetails.badges"
          >
          </activity-overall-info>
      </md-card>
    </div>
    </div>
    <div class="row md-layout-item md-size-100">
      <div class="md-layout-item md-size-60" v-if="activityDetails && activityDetails.titleImage">
        <md-card style="padding: 24px 16px">
          <span class="map-title">Route</span>
          <img :src="activityDetails.titleImage" class="route-image">
        </md-card>
      </div>
    </div>
    <modal v-if="showManualActivityDialog">
      <template slot="header"><h3>Aktivität bearbeiten</h3></template>
      <template slot="body">
        <manual-activity-form
          :activityFromParent="activityDetails"
          :fullWidth="true"
          @cancelClicked="showManualActivityDialog = false"
          @submitClicked="submitForm($event)">
        </manual-activity-form>
      </template>
    </modal>
    <div class="md-layout-item  md-medium-size-50">
      <md-card></md-card>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Modal from '../../components/Modal';
// import ManualActivityForm from '../../atomic-design/molecules/manual-activity-form';
// import ActivityOverallInfo from '../../atomic-design/molecules/activity-overall-info';
import ManualActivityForm from 'sports4me-web_components/atomic-design/molecules/manual-activity-form';
import ActivityOverallInfo from 'sports4me-web_components/atomic-design/molecules/activity-overall-info';

export default {
  components: {
    Modal,
    ManualActivityForm,
    ActivityOverallInfo,
  },
  data() {
    return {
      activityDetails: null,
      activityIdFromRouter: this.$route.params.id,
      // activity: {
      //   images: [],
      //   activityType: 1,
      //   data: {
      //     distanceInMeters: null,
      //     averagePaceInMinutesPerKilometer: 0,
      //   }
      // },
      showManualActivityDialog: false,
      activityImage: null,
      durationInSeconds: 0,
      distanceInMeters: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      speedInKm: 0,
    }
  },
  watch: {
    $route(to, from) {
      this.activityIdFromRouter = to.params.id;
    }
  },
  methods: {
    submitForm(data) {
      const body = { url: '/rest/activity/createForMe', data: data };
      this.$store
        .dispatch("postAPI", {
          url: body.url,
          data: body.data
        })
        .then(res => {
          this.$notify({
            timeout: 5000,
            message: "Erfogleicht bearbeitet",
            type: "success",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          this.showManualActivityDialog = false
        })
        .catch(err => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            type: "error",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
        });
    },
  },
  mounted() {
      this.$store
          .dispatch("getActivityDetails", this.activityIdFromRouter)
          .then(data => {
            this.activityDetails = data;
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          });

  },
  computed: {
    ...mapState({
      activity: state => state.activityDetail,
      userId: state => state.user && state.user._id,
    }),
  }
}

</script>
<style lang="scss">
:host {
  display: block;
}

.map-title {
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 12px;
}
.route-image {
  border-radius: 6px;
}
</style>
